import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { selectTourState } from 'features/tour/tourSelectors';

import { useAppSelector } from 'hooks/useTypedRedux';

import { APPLICATIONS, HOME, JOBS } from 'constants/path';

export const useSyncJobRoute = (
  jobId?: string | null,
  isBlockUrlHandling = false
): void => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const tourState = useAppSelector(selectTourState);

  useEffect(() => {
    if (!jobId || isBlockUrlHandling) {
      return;
    }

    const isFullTour =
      tourState.steps.length > 0 && tourState.steps[0]?.page === HOME;
    const hasApplicationSteps = tourState.steps.some((step) =>
      step.page?.startsWith(APPLICATIONS)
    );

    if (isFullTour && hasApplicationSteps && tourState.run) {
      return;
    }

    const firstPathPart = pathname.split('/')?.[1];
    const isJobsRoute = firstPathPart === JOBS.slice(1);

    if (isJobsRoute) {
      navigate(`${JOBS}/${jobId}`);
    }

    return () => {
      if (isJobsRoute) {
        navigate(JOBS);
      }
    };
  }, [
    jobId,
    isBlockUrlHandling,
    navigate,
    pathname,
    tourState.run,
    tourState.steps,
    tourState.steps.length
  ]);
};
